module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"descrip_empresa":"Información de la empresa","descrip_producto":"Descripción del producto","label_material":"Material:","label_marca":"Marca:","label_colec":"Colección - Pieza:","label_enlace":"Enlace web:","label_formato":"Formato (cm):","label_espesor":"Espesor (mm):","absorcion_agua":"Absorción de agua"}}')
  delete Component.options._Ctor
}
